import axios from "../http"; // 导入axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const getArticle ={
    getNewsInfo(params) {
        return axios.post(`/mobile/news/news_info`,qs.stringify(params));
    },
    getNewsTj(params) {
        return axios.post(`/mobile/news/news_tj`,qs.stringify(params));
    },
    getNewsCate(params) {
        return axios.post(`/mobile/news/news_cate`, qs.stringify(params));
    },
    getNewsList(params) {
        return axios.post(`/mobile/news/news_lists`, qs.stringify(params));
    },
    //热门文章
    news_hit(params) {
        return axios.post(`/mobile/news/news_hit`, qs.stringify(params));
    },
    //精选文章
    news_selection(params) {
        return axios.post(`/mobile/news/news_selection`, qs.stringify(params));
    },
}
export default getArticle;


// WEBPACK FOOTER //
// ./src/assets/js/api/require/article.js